import React from 'react';
import cn from 'clsx';

import StreetViewSolidIcon from '../../shared/icons/street-view-solid-icon';

import styles from './toggle.scss';

interface ToggleProps {
  ariaLabelledBy: string;
  icon?: React.ReactElement;
  isEnabled: boolean;
  label?: React.ReactElement;
  onToggle: () => void;
}

function Toggle(props: ToggleProps): React.ReactElement {
  const { ariaLabelledBy, icon, isEnabled, label, onToggle } = props;

  return (
    <label
      aria-labelledby={ariaLabelledBy}
      className={cn(styles['container'], 'toggle')}
    >
      <input className={styles['input']} onChange={onToggle} type="checkbox" />
      <div
        className={cn(
          `${styles['indicator']} ${
            isEnabled ? styles['indicator--checked'] : ''
          }`,
          `toggle__indicator ${isEnabled ? 'toggle__indicator--checked' : ''}`
        )}
      >
        <div className={cn(styles['circle'], 'toggle__circle')}>
          {icon ?? <StreetViewSolidIcon />}
        </div>
      </div>
      {label}
    </label>
  );
}

export default Toggle;
